module.exports = __webpack_public_path__ + "static/media/PlayStore.e65a89bc.png";